module.exports = __webpack_public_path__ + "static/img/signSucess.6600c891.png";